import React, { useEffect, useState, useCallback } from 'react'
import { Text } from 'rebass'
import styled from 'styled-components'
import { AuctionBake } from '../../constants/artwork'

// utils
import { DISHESDICT } from '../../constants/bakery/nft'
import { BigNumber } from 'bignumber.js'
import { BIGNUMBER_FMT } from '../../constants/bakery'

// components
import { BodyHead, BodyTitle } from '../../components/bakery/styleds'
import { Card } from '../../components/bakery/styleds'
import { ButtonLight, ButtonConfirmed } from '../../components/Button'
import PlateCard from '../../components/restaurant/PlateCard'
import Value from '../../components/Value/OnlyValue'
import Loader from '../../components/Loader'
import { AutoRow } from '../../components/Row'
import FoodsList from '../../components/restaurant/FoodsList'
import ExchangeBakeVersion from '../../components/Gamification/ExchangeBakeVersion'
import { useBakeLevel } from '../../state/bakePool/hooks'
import {  NFTTYPE } from '../../constants/bakery/nft'

// hooks
import { useActiveWeb3React } from '../../hooks'
import { useWalletModalToggle } from '../../state/application/hooks'
import useAllDishes from '../../hooks/nft/useAllDishes'
import useAllNtfEarnings from '../../hooks/nft/useAllNtfEarnings'
import useStakingPower from '../../hooks/nft/useStakingPower'
import useApproveDish from '../../hooks/nft/useApproveNFT'
import useStakeDish from '../../hooks/nft/useStakeDish'
import useUnstakeDish from '../../hooks/nft/useUnstakeDish'
import useHarvestDish from '../../hooks/nft/useHarvestDish'
import useDecomposition from '../../hooks/nft/useDecomposition'
import useUnstakeBulk from '../../hooks/nft/useUnstakeBulk'
import useBlock from '../../hooks/bakery/useBlock'
import useRoi from '../../hooks/nft/useRoi'
import useInterval from '../../hooks/useInterval'
import { MARKETTYPE, MARKETTYPEV3, MARKETTYPEV1, SUPPORTTYPE } from '../../constants/bakery/nft'
import ArtworkBtn from '../../components/nftInfo/button/ArtworkBtn'
import useUserStakes from '../../hooks/nft/useUserStakes'

import useAllowanceAll from '../../hooks/nft/useAllowanceAll'
import useUserBids from '../../hooks/nft/useUserBids'
import useUserAsks from '../../hooks/nft/useUserAsks'
import { getBakeryCombos, getBakeryCombosV2, getBakeryCombosV3 } from '../../service/nft'

interface DishInfos {
  id: string
  level: number
  stakingPowerMultiple: number
  bakeAmount: BigNumber
  stakingPowerAmount: BigNumber
  items: string[]
  tokenId: string
  nftType: number
  auctionPrice: string
  staking?: boolean
  maxBidPrice: string
}

const CardWrapper = styled.div`
  display: flex;
  font-family: Baloo Da;
  width: 892px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    flex-direction: column;
    align-items: center;
    width: auto;
  `}
`
const StakeCard = styled(Card)`
  flex: 1;
  color: ${({ theme }) => theme.primary1};
  text-align: center;
  padding: 24px 0;

  &:first-child {
    margin-right: 24px;
  }

  ${({ theme }) => theme.mediaWidth.upToMedium`
    &:first-child {
      margin: 0 0 24px 0;
    }
  `}
`
const AmountText = styled.div`
  color: ${({ theme }) => theme.bsText4};
  margin: 16px 0 24px;
`
const ButtonLightOverride = styled(ButtonLight)`
  width: 296px;
  margin: 0 auto;
  padding: 6px 18px;
`
const StakeRow = ({type}: {type: string}) => {
  const { account } = useActiveWeb3React()
  const sumEarning = useAllNtfEarnings(type)
  const sumEarningV2 = useAllNtfEarnings(type + "_V2")

  const stakingPower = useStakingPower(type)
  const stakingPowerV2 = useStakingPower(type + "_V2")


  // harvest
  const onHarvestDish = useHarvestDish(type)
  const onHarvestDishV2 = useHarvestDish(type + "_V2")

  const [requestedHarvest, setRequestedHarvest] = useState(false)
  const handleHarvest = useCallback(async () => {
    try {
      let txHash:any = true
      let txHashV2:any = true
      if([
        NFTTYPE.DOGGIES,
        NFTTYPE.BARKING,
        NFTTYPE.EQUIPMENT,
        NFTTYPE.BAKEMUSKMIXER,
        NFTTYPE.CAR,
        NFTTYPE.COMBO,
        NFTTYPE.SOCCER,
        NFTTYPE.POKER,
      ].includes(type)){
        if(stakingPower.toNumber() && stakingPowerV2.toNumber()){
          const harvestArray = [onHarvestDish, onHarvestDishV2]
          harvestArray.map(async(d, index) => {
            if(index === 0){
              txHash = await d()
            }else{
              txHashV2 = await d()
            }
            if (!txHash && !txHashV2) {
              setRequestedHarvest(false)
            } else {
              setTimeout(() => {
                setRequestedHarvest(false)
              }, 15000)
            }
          })
        }else if(stakingPowerV2.toNumber() * 1){
          txHash = await onHarvestDishV2()
          txHashV2 = false
        }else{
          txHash = await onHarvestDish()
          txHashV2 = false
        }
      }else{
        txHash = await onHarvestDish()
        txHashV2 = false
      }
      if (!txHash && !txHashV2) {
        setRequestedHarvest(false)
      } else {
        setTimeout(() => {
          setRequestedHarvest(false)
        }, 15000)
      }
    } catch (e) {
      setRequestedHarvest(false)
      console.log(e)
    }
  }, [onHarvestDish, onHarvestDishV2, type, stakingPower, stakingPowerV2])

  // unstake all
  const onUnstakeBulk = useUnstakeBulk(type)
  const onUnstakeBulkV2 = useUnstakeBulk(type + "_V2")

  const [requestedUnstakeBulk, setRequestedUnstakeBulk] = useState(false)
  const handleUnstakeBulk = useCallback(async () => {
    try {
      setRequestedUnstakeBulk(true)
      let txHash:any = true
      let txHashV2:any = true
      if([
        NFTTYPE.DOGGIES,
        NFTTYPE.BARKING,
        NFTTYPE.EQUIPMENT,
        NFTTYPE.BAKEMUSKMIXER,
        NFTTYPE.CAR,
        NFTTYPE.COMBO,
        NFTTYPE.SOCCER,
        NFTTYPE.POKER,
      ].includes(type)){
        if(stakingPower.toNumber() && stakingPowerV2.toNumber()){
          const unstakeArray = [onUnstakeBulk, onUnstakeBulkV2]
          unstakeArray.map(async(d) => {
            txHash = await d()
            setTimeout(() => {
              txHashV2 = false
            }, 15000)
          })
        }else if(stakingPowerV2.toNumber() * 1){
          txHash = await onUnstakeBulkV2()
          txHashV2 = false
        }else{
          txHash = await onUnstakeBulk()
          txHashV2 = false
        }
      }else{
        txHash = await onUnstakeBulk()
        txHashV2 = false
      }
      if (!txHash && !txHashV2) {
        setRequestedUnstakeBulk(false)
      } else {
        setTimeout(() => {
          setRequestedUnstakeBulk(false)
        }, 15000)
      }
    } catch (e) {
      setRequestedUnstakeBulk(false)
      console.log(e)
    }
  }, [onUnstakeBulk, onUnstakeBulkV2, type, stakingPower, stakingPowerV2])

  return (
    <CardWrapper>
      <StakeCard>
        <Text fontSize={16}>BAKE Earned</Text>
        <AmountText>
          <Text fontSize={36}>
          {
              [
                NFTTYPE.DOGGIES,
                NFTTYPE.BARKING,
                NFTTYPE.EQUIPMENT,
                NFTTYPE.BAKEMUSKMIXER,
                NFTTYPE.CAR,
                NFTTYPE.COMBO,
                NFTTYPE.SOCCER,
                NFTTYPE.POKER,
              ].includes(type) ? (
                <Value decimals={3} value={sumEarning.toNumber() + sumEarningV2.toNumber()} />
              ) : (
                <Value decimals={3} value={sumEarning.toNumber()} />
              )
            }
          </Text>
        </AmountText>
        <ButtonConfirmed
          onClick={handleHarvest}
          disabled={!account ||  (sumEarning.lte(0) && sumEarningV2.lte(0)) || requestedHarvest}
          fontSize={14}
          width={276}
          height={40}
          margin="0 auto"
          padding="0px 18px"
        >
          {requestedHarvest ? (
            <AutoRow gap="6px" justify="center">
              Collecting <Loader stroke="white" />
            </AutoRow>
          ) : (
            'Harvest'
          )}
        </ButtonConfirmed>
      </StakeCard>
      <StakeCard>
        <Text fontSize={16}>Staking Power</Text>
        <AmountText>
          <Text fontSize={36}>
          {
              [
                NFTTYPE.DOGGIES,
                NFTTYPE.BARKING,
                NFTTYPE.EQUIPMENT,
                NFTTYPE.BAKEMUSKMIXER,
                NFTTYPE.CAR,
                NFTTYPE.COMBO,
                NFTTYPE.SOCCER,
                NFTTYPE.POKER,
              ].includes(type) ? (
                <Value decimals={3} value={stakingPower.toNumber() + stakingPowerV2.toNumber()} />
              ) : (
                <Value decimals={3} value={stakingPower.toNumber()} />
              )
            }
          </Text>
        </AmountText>
        <ButtonConfirmed
          onClick={handleUnstakeBulk}
          disabled={requestedUnstakeBulk || (stakingPower.lte(0) && stakingPowerV2.lte(0))}
          fontSize={14}
          width={276}
          height={40}
          margin="0 auto"
          padding="0px 18px"
        >
          {requestedUnstakeBulk ? (
            <AutoRow gap="6px" justify="center">
              Unstaking <Loader stroke="white" />
            </AutoRow>
          ) : (
            'Unstake'
          )}
        </ButtonConfirmed>
      </StakeCard>
    </CardWrapper>
  )
}

const ListWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 892px;
  margin-top: 97px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    flex-direction: column;
    align-items: center;
    width: auto;
  `}
`
const CardItem = styled.div`
  width: 280px;
  margin-bottom: 80px;
  &:not(:nth-child(3n)) {
    margin-right: 25px;
  }

  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin-bottom: 64px;

    &:not(:nth-child(3n)) {
      margin-right: initial;
    }
  `}
`
const CardTitle = styled.div`
  padding: 16px 16px 8px;
`
const AttachWrapper = styled.div`
  margin-top: 16px;
`
const AttachRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  &:firt-child {
    margin-top: 32px;
  }
`
const ValueItem = styled.div`
  display: flex;
  align-items: center;
`
const ButtonGroupsWrapper = styled.div`
  padding: 22px 0;
`
const ButtonGroup = styled.div`
  display: flex;
  padding: 0 16px;
  button:first-child {
    padding: 0 12px;
  }
  button:last-child {
    flex: 1;
  }
  button:nth-child(2) {
    margin-left: 8px;
  }
`
const BakeText = styled.div`
  margin-left: 5px;
`

const DishBox = ({ dish, currentBlock, allowanceSellAll, type }: { dish: any, currentBlock: number, allowanceSellAll?: boolean, type: string }) => {
  const roi = useRoi(currentBlock, dish.stakingPowerMultiple, type)
  const { account } = useActiveWeb3React()

  let marketType = ''
  if (dish.level === 'v1') {
    marketType = MARKETTYPEV1.DISHV1
  } else if (dish.level === 'v2') {
    marketType = MARKETTYPE.DISH
  } else if (dish.level === 'v3') {
    marketType = MARKETTYPEV3.DISHV3
  }
  // 获取我的竞价
  const getBids = useUserBids(marketType)
  const emptyBids: any[] = []
  const [ids, setIds] = useState(emptyBids)
  const getIds = useCallback(async() => {
    const bids = await getBids()
    if (bids.length) {
      const bidsId = bids.map((d: any) => {
        return d[0]
      })
      setIds(bidsId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getBids])

  // 获取我的挂单
  const getAsks = useUserAsks(marketType)
  const emptyAsks: any[] = []
  const [aksIds, setAskIds] = useState(emptyAsks)
  const getAskIds = useCallback(async() => {
    const asks = await getAsks()
    if (asks.length) {
      const asksId = asks.map((d: any) => {
        return d[0]
      })
      setAskIds(asksId)
    }
  }, [getAsks])

  useEffect(() => {
    if (account) {
      getAskIds()
      getIds()
    }
  }, [getBids, getIds, getAskIds, getAsks, account, dish])

  // approve ntf
  const STAKE = 'STAKE'
  const DECOMPOSE = 'DECOMPOSE'
  // const [resetApprovalStake, setResetApprovalStake] = useState(false)
  const [requestedApproval, setRequestedApproval] = useState(false)
  const [requestedApprovalDecompose, setRequestedApprovalDecompose] = useState(false)
  // const allowance1 = useAllowanceNFT({
  //   tokenId: dish.tokenId,
  //   requested: requestedApproval || requestedApprovalDecompose,
  //   reset: resetApprovalStake
  // })
  const allowanceDecomposing = useAllowanceAll({type: NFTTYPE.COMBO})
  const allowance1 = useAllowanceAll({type: NFTTYPE.COMBO})
  const allowance2 = useAllowanceAll({type: NFTTYPE.COMBO_V3})
  let allowance = allowance1 
  if(type === NFTTYPE.COMBO_V3){
    allowance = allowance2
  }
  const { onApprove } = useApproveDish(dish.tokenId, type)
  const handleApprove = useCallback(
    async (type: string) => {
      try {
        if (type === STAKE) {
          setRequestedApproval(true)
        } else {
          setRequestedApprovalDecompose(true)
        }
        const txHash = await onApprove(type)
        if (!txHash) {
          if (type === STAKE) {
            setRequestedApproval(false)
          } else {
            setRequestedApprovalDecompose(false)
          }
        } else {
          setTimeout(() => {
            if (type === STAKE) {
              setRequestedApproval(false)
            } else {
              setRequestedApprovalDecompose(false)
            }
          }, 10000)
        }
      } catch (e) {
        console.log(e)
      }
    },
    [onApprove, setRequestedApproval]
  )

  // stake
  const { onStakeDish } = useStakeDish(dish.tokenId, type)
  const [requestedStake, setRequestedStake] = useState(false)
  const handleStake = useCallback(async () => {
    try {
      setRequestedStake(true)
      const txHash = await onStakeDish()
      // user rejected tx or didn't go thru
      console.log(txHash)
      if (!txHash) {
        setRequestedStake(false)
      } else {
        setTimeout(() => {
          setRequestedStake(false)
        }, 10000)
      }
    } catch (e) {
      console.log(e)
    }
  }, [onStakeDish])

  // unstake
  const emptyStakes: any[] = []
  const [stakesIds_v2, setStakesIds_V2] = useState(emptyStakes)

  // 存v2的
  const getStakesV2 = useUserStakes(type + "_V2")
  const getStakesIds = useCallback(async () => {
    let stakesV2:any = []
    if([
      NFTTYPE.DOGGIES,
      NFTTYPE.BARKING,
      NFTTYPE.EQUIPMENT,
      NFTTYPE.BAKEMUSKMIXER,
      NFTTYPE.CAR,
      NFTTYPE.COMBO,
      NFTTYPE.SOCCER,
      NFTTYPE.POKER,
    ].includes(type)){
      stakesV2 = await getStakesV2()
    }
    if (stakesV2.length) {
      const stakesIdV2 = stakesV2.map((d: any) => {
        return d
      })
      setStakesIds_V2(stakesIdV2)
    } else {
      setStakesIds_V2([])
    }
  }, [getStakesV2, type])

  useEffect(() => {
    getStakesIds()
  }, [dish, getStakesIds])

  const onUnstakeDish = useUnstakeDish(dish.tokenId, type)
  const onUnstakeDishV2 = useUnstakeDish(dish.tokenId, type + '_V2')
  const [requestedUnstake, setRequestedUnstake] = useState(false)
  const handleUnstake = useCallback(async () => {
    try {
      setRequestedUnstake(true)
      // const txHash = await onUnstakeDish()
      let txHash:any
      if(stakesIds_v2.includes(dish.tokenId)){
        txHash = await onUnstakeDishV2()
      }else{
        txHash = await onUnstakeDish()
      }
      // user rejected tx or didn't go thru
      if (!txHash) {
        setRequestedUnstake(false)
      } else {
        // Reset allowance
        // setResetApprovalStake(false)
        setTimeout(() => {
          // setResetApprovalStake(true)
          setRequestedUnstake(false)
        }, 10000)
      }
    } catch (e) {
      console.log(e)
    }
  }, [onUnstakeDish, stakesIds_v2])

  // Decompose
  const { onDecomposition } = useDecomposition(dish.tokenId)
  const [requestedDecompose, setRequestedDecompose] = useState(false)
  const handleDecompose = useCallback(async () => {
    try {
      setRequestedDecompose(true)
      const txHash = await onDecomposition()
      // user rejected tx or didn't go thru
      if (!txHash) {
        setRequestedDecompose(false)
      }
    } catch (e) {
      console.log(e)
    }
  }, [onDecomposition])

  // // v2查询是否授权卖
  // const [requestedApprovalAllExchange, setRequestedApprovalAllExchange] = useState(false)
  // const onApproveSellAll = useApproveAllERC721(marketType, 'market')
  // const handleApproveSellAll = useCallback(
  // async (event) => {
  //   try {
  //     setRequestedApprovalAllExchange(true)
  //     const txHash = await onApproveSellAll()
  //     if (!txHash) {
  //       setRequestedApprovalAllExchange(false)
  //     } else {
  //       setTimeout(() => {
  //         setRequestedApprovalAllExchange(false)
  //       }, 10000)
  //     }
  //   } catch (e) {
  //     console.log(e)
  //   }
  // },
  //   [onApproveSellAll, setRequestedApprovalAllExchange]
  // )

  // // Order
  // const { onSell } = useSell(dish.tokenId, marketType)
  // const [artworkExchange] = useModal(
  //   <SellComboModal
  //     onConfirm={onSell}
  //     tokenName="BAKE"
  //     min={dish.bakeAmount}
  //     title="Please set the selling price"
  //   />,
  // )
  
  // // Auction
  // const { onAuction } = useAuction(dish.tokenId, dish.nftType?.toString())
  // const [auctionkExchange] = useModal(
  //   <SellComboModal
  //     onConfirm={onSell}
  //     tokenName="BAKE"
  //     min={dish.bakeAmount}
  //     title="Please set the opening price"
  //     type="Auction"
  //     onAuction={onAuction}
  //   />,
  // )

  // const onPresentExchange = useCallback(async (event, type) => {
  //   if (type === 'sell') {
  //     artworkExchange()
  //   } else if (type === 'Auction') {
  //     auctionkExchange()
  //   }
  // }, [artworkExchange, auctionkExchange])

  // // revoke exchange
  // const { onRevokeExchange } = useRevokeExchange(dish.tokenId, marketType)
  // const [requestedRevoke, setRequestedRevoke] = useState(false)
  // const handleRevoke = useCallback(async () => {
  //   try {
  //     setRequestedRevoke(true)
  //     const txHash = await onRevokeExchange()
  //     if (!txHash) {
  //       setRequestedRevoke(false)
  //     } else {
  //       // reset allowanceSell
  //       // setResetApprovalSell(false)
  //       setTimeout(() => {
  //         // setResetApprovalSell(true)
  //         setRequestedRevoke(false)
  //       }, 10000)
  //     }
  //   } catch (e) {
  //     console.log(e)
  //   }
  // }, [onRevokeExchange])

  // //授权竞价
  // // const [requestedApprovalBid, setRequestedApprovalBid] = useState(false)
  // // const onApproveBid = useApproveBid(MARKETTYPE.DISH)
  // // const handleApproveBid = useCallback(async (event) => {
  // //   try {
  // //     setRequestedApprovalBid(true)
  // //     const txHash = await onApproveBid()
  // //     if (!txHash) {
  // //       setRequestedApprovalBid(false)
  // //     }
  // //   } catch (e) {
  // //     console.log(e)
  // //   }
  // // }, [onApproveBid, setRequestedApprovalBid])

  // // 竞价
  // const handBid = () => {
  //   if (ids.includes(dish.tokenId)) {
  //     onUpdateBid()
  //     return
  //   }
  //   if (aksIds.includes(dish.tokenId)) {
  //     onLookBidding()
  //   } else {
  //     onBidding()
  //   }
  // }
  // // 将token卖给指定地址
  // const {onSellBid} = useSellTokenTo(dish.tokenId, marketType) 
  // const onSellTokenTo = useCallback(async (address: string) => {
  //   try {
  //     const txHash = await onSellBid(address)
  //     console.log('------->txHash', txHash)
  //   } catch (e) {
  //     console.log(e)
  //   }
  // }, [onSellBid])

  // // Bidding
  // const {onBid} = useBid(dish.tokenId, marketType) 
  // const {onMaxBidPrice} = useMaxBidPrice(dish.tokenId, dish.nftType)
  // const handleBid = useCallback(async (amount: string) => {
  //   try {
  //     const txHash = await onBid(amount)
  //     txHash && dish.auctionPrice && await onMaxBidPrice(new BigNumber(amount).div(new BigNumber(10).pow(18)).toString())
  //     console.log('------>txHash', txHash)
  //   } catch (e) {
  //     console.log(e)
  //   }
  // }, [onBid, onMaxBidPrice, dish])
  // const [bidding] = useModal(
  //   <BiddingModal
  //     onSellTokenTo={onSellTokenTo}
  //     onConfirm={handleBid}
  //     isBidding={true}
  //     tokenId={dish.tokenId}
  //     type={marketType}
  //     auctionPrice={dish.auctionPrice}
  //   />,
  // )
  // const onBidding = useCallback(async () => {
  //   bidding()
  // }, [bidding])

  // // 查看竞价列表
  // const [lookBidding] = useModal(
  //   <BiddingModal
  //     onSellTokenTo={onSellTokenTo}
  //     onConfirm={onBid}
  //     isBidding={false}
  //     tokenId={dish.tokenId}
  //     type={marketType}
  //     auctionPrice={dish.auctionPrice}
  //   />,
  // )
  // const onLookBidding = useCallback(async () => {
  //   lookBidding()
  // }, [lookBidding])
  
  // // 更新竞价
  // const {onUpdate} = useUpdateBid(dish.tokenId, marketType, dish.auctionPrice ? onMaxBidPrice : '')
  // const [updateBid] = useModal(
  //   <BiddingModal
  //     onSellTokenTo={onSellTokenTo}
  //     onConfirm={onUpdate}
  //     isBidding={true}
  //     tokenId={dish.tokenId}
  //     type={MARKETTYPE.DISH}
  //     auctionPrice={dish.auctionPrice}
  //   />,
  // )
  // const onUpdateBid = useCallback(async () => {
  //   updateBid()
  // }, [updateBid])

  // // 移除竞价
  // const cancelBid = useCancelBid(dish.tokenId, marketType)
  // const [requestedCancel, setRequestedCancel] = useState(false)
  // const onCancelBid = useCallback(async(event) => {
  //   try {
  //     setRequestedCancel(true)
  //     const txHash = await cancelBid()
  //     if (!txHash) {
  //       setRequestedCancel(false)
  //     } else {
  //       setTimeout(() => {
  //         setRequestedCancel(false)
  //       }, 10000)
  //     }
  //   } catch (e) {
  //     console.log(e)
  //   }
  // }, [cancelBid])

  return (
    <CardItem>
      <PlateCard
        dish={dish}
        ids={ids}
        iconUrl={(process.env.REACT_APP_DISH_URL ?? '') + '/api/set0001/' + dish.dishIcon}
        level={dish.levelNft + 1}
        headerHeight={170}
        isMydish={true}
      >
        
        <CardTitle>
          <Text fontSize={22}>{DISHESDICT[dish.levelNft]}</Text>
        </CardTitle>
        <FoodsList items={dish.items}></FoodsList>
        <AttachWrapper>
          <AttachRow>
            <Text fontSize={14}>Decompose to get:</Text>
            <ValueItem>
              <Value decimals={0} value={dish.bakeAmount.toNumber()} />
              <BakeText>BAKE</BakeText>
            </ValueItem>
          </AttachRow>
          <AttachRow>
            <Text fontSize={14}>Staking Power:</Text>
            <Text>
              <Value decimals={0} value={dish.stakingPowerAmount.toNumber()} />
            </Text>
          </AttachRow>
          <AttachRow>
            <Text fontSize={14}>ROI:</Text>
            <Text>
              <Value
                decimals={0}
                value={
                  roi && !roi.isNaN() && roi.gt(0)
                    ? roi.times(new BigNumber(100)).toFormat(2, BIGNUMBER_FMT) + '%'
                    : '-'
                }
              />
            </Text>
          </AttachRow>
          <AttachRow style={{margin: '15px 0 -15px'}}>
            <Text fontSize={14}>Price(BAKE):</Text>
            <Text fontSize={22}>
              <Value decimals={0} value={dish.price ? new BigNumber(!dish.auctionPrice ? dish.price : dish.maxBidPrice).integerValue(BigNumber.ROUND_CEIL).toFormat(0, BIGNUMBER_FMT) : '-'} />
            </Text>
          </AttachRow>
        </AttachWrapper>
        <ButtonGroupsWrapper>
          {
            +dish.price || ids.includes(dish.id) ? (
              <ButtonGroup>
                <ButtonConfirmed
                  disabled={true}
                  fontSize={14}
                  width="auto"
                  height={40}
                  altDisabledStyle={true}
                >Decompose</ButtonConfirmed>
                <ButtonConfirmed
                  disabled={true}
                  fontSize={14}
                  height={40}
                  altDisabledStyle={true}
                >Approve NFT</ButtonConfirmed>
              </ButtonGroup>
            ) : (
              <ButtonGroup>
                {dish.staking ? null : allowanceDecomposing ? (
                  <ButtonConfirmed
                    onClick={handleDecompose}
                    disabled={requestedDecompose || requestedStake || requestedApproval || dish.staking2}
                    fontSize={14}
                    width="auto"
                    height={40}
                    altDisabledStyle={requestedDecompose || requestedStake || requestedApproval || dish.staking2} // show solid button while waiting
                  >
                    {requestedDecompose ? 'Decomposing' : 'Decompose'}
                  </ButtonConfirmed>
                ) : (
                  <ButtonConfirmed
                    onClick={handleApprove.bind(null, DECOMPOSE)}
                    disabled={requestedApprovalDecompose || requestedStake || requestedApproval || dish.staking2}
                    fontSize={14}
                    width="auto"
                    height={40}
                    altDisabledStyle={requestedApprovalDecompose || requestedStake || requestedApproval || dish.staking2} // show solid button while waiting
                  >
                    {requestedApprovalDecompose ? 'Approving' : 'Decompose'}
                  </ButtonConfirmed>
                )}
                {dish.staking ? (
                  <ButtonConfirmed
                    onClick={handleUnstake}
                    disabled={requestedUnstake || requestedDecompose || requestedApprovalDecompose}
                    fontSize={14}
                    height={40}
                    altDisabledStyle={requestedUnstake || requestedDecompose || requestedApprovalDecompose} // show solid button while waiting
                  >
                    {requestedUnstake ? (
                      <AutoRow gap="6px" justify="center">
                        Unstaking <Loader stroke="white" />
                      </AutoRow>
                    ) : (
                      'Unstake'
                    )}
                  </ButtonConfirmed>
                ) : allowance ? (
                  <ButtonConfirmed
                    onClick={handleStake}
                    disabled={requestedStake || requestedDecompose || requestedApprovalDecompose || dish.staking2}
                    fontSize={14}
                    height={40}
                    altDisabledStyle={requestedStake || requestedDecompose || requestedApprovalDecompose || dish.staking2} // show solid button while waiting
                  >
                    {requestedStake ? (
                      <AutoRow gap="6px" justify="center">
                        Staking <Loader stroke="white" />
                      </AutoRow>
                    ) : (
                      'Stake NFT '
                    )}
                  </ButtonConfirmed>
                ) : (
                  <ButtonConfirmed
                    onClick={handleApprove.bind(null, STAKE)}
                    disabled={requestedApproval || requestedDecompose || requestedApprovalDecompose}
                    fontSize={14}
                    height={40}
                    altDisabledStyle={requestedApproval || requestedDecompose || requestedApprovalDecompose} // show solid button while waiting
                  >
                    {requestedApproval ? (
                      <AutoRow gap="6px" justify="center">
                        Approving <Loader stroke="white" />
                      </AutoRow>
                    ) : (
                      'Approve NFT'
                    )}
                  </ButtonConfirmed>
                )}
              </ButtonGroup>
            )
          }
            <ButtonGroup style={{marginTop: 8}}>
            {
              !dish.staking && !dish.staking2 &&
              <ArtworkBtn
                artwork={dish}
                status={1}
                isMyArtwork={true}
                ids={ids}
                myAksIds={aksIds}
                marketType={marketType}
                symbol={SUPPORTTYPE.BAKE}
              />
            }
            </ButtonGroup>
        </ButtonGroupsWrapper>
      </PlateCard>
    </CardItem>
  )
}

const MyDishesList = ({ dishes, currentBlock, allowanceSellAll, type }: { dishes: DishInfos[], currentBlock: number, allowanceSellAll?: boolean, type: string }) => {
  const Row = dishes.map((d) => {
    return <DishBox key={d.id} dish={d} allowanceSellAll={allowanceSellAll} currentBlock={currentBlock} type={type}/>
  })
  return <ListWrapper>{Row}</ListWrapper>
}

export default function MyDishes() {
  const currentBlock = useBlock()
  const { account, chainId } = useActiveWeb3React()
  const [dishes, setDishes] = useState<any[]>([])
  const bakeLevel = useBakeLevel()
  let gameType:any = NFTTYPE.COMBO
  if(bakeLevel === 'v1'){
    gameType = NFTTYPE.COMBO
  }
  if(bakeLevel === 'v2'){
    gameType = NFTTYPE.COMBO_V3
  }

  const getAllDishesV1 = useAllDishes(false, gameType, MARKETTYPEV1.DISHV1)
  const getAllDishesV2 = useAllDishes(false, gameType, MARKETTYPE.DISH)
  const getAllDishesV3 = useAllDishes(false, gameType, MARKETTYPEV3.DISHV3)


  const fetchAllDishes = async () => {
    const listV1 = await getAllDishesV1(true)
    const listV2 = await getAllDishesV2(true)
    const listV3 = await getAllDishesV3()

    const stakeIds1 = listV3.filter((d) => {
      return d.staking
    }).map((d) => {
      return d.tokenId
    })

    const stakeIds2 = listV3.filter((d) => {
      return d.staking2
    }).map((d) => {
      return d.tokenId
    })

    const allList1 = listV1.map((d) => {
      return d.tokenId
    })
    const allList2 = listV2.map((d) => {
      return d.tokenId
    })
    const allList3 = listV3.map((d) => {
      return d.tokenId
    })
    if (allList1.length || allList2.length || allList3.length) {
      fetchAsksSort({
        'v1': allList1,
        'v2': allList2,
        'v3': allList3
      }, stakeIds1, stakeIds2)
    }
    if (!allList1.length && !allList2.length && !allList3.length) {
      setDishes([])
    }
    // if (list.length) {
    //   fetchAsksSort(list)
    // } else {
    //   setDishes([])
    // }
    // const handledList = list?.map(data => {
    //   return {
    //     ...data,
    //     dishIcon:
    //       data.items
    //         .map((d: string | number) => {
    //           const valBinary = new BigNumber(d)
    //             .div(100000)
    //             .integerValue(BigNumber.ROUND_FLOOR)
    //             .toString(2)
    //           return valBinary.length < 2 ? '0' + valBinary : valBinary
    //         })
    //         .join('') + '.svg',
    //     nftType: 10,
    //     auctionPrice: ((data.auctionPrice && Number(data.auctionPrice)) && (data.price && Number(data.price) && +data.price === AuctionBake) ? data.auctionPrice : '')
    //   }
    // })
    // setDishes(handledList)
  }

  const getDataV1 = (params: any) => {
    return new Promise((resolve, reject) => {
      getBakeryCombos(chainId as number, params, (err: any, data: any) => {
        if (err) {
          reject()
          return
        }
        if (data.code !== 0) {
          reject()
          return
        }
        const dataAry = data.data.list || []
        dataAry.forEach((d: any) => {
          d.levelNft = d.level
          d.level = 'v1'
        })
        resolve(dataAry)
      })
    })
    .catch(() => [])
  }
  const getDataV2 = (params: any) => {
    return new Promise((resolve, reject) => {
      getBakeryCombosV2(chainId as number, params, (err: any, data: any) => {
        if (err) {
          reject()
          return
        }
        if (data.code !== 0) {
          reject()
          return
        }
        const dataAry = data.data.list || []
        dataAry.forEach((d: any) => {
          d.levelNft = d.level
          d.level = 'v2'
        })
        resolve(dataAry)
      })
    })
    .catch(() => [])
  }
  const getDataV3 = (params: any) => {
    return new Promise((resolve, reject) => {
      getBakeryCombosV3(chainId as number, params, (err: any, data: any) => {
        if (err) {
          reject()
          return
        }
        if (data.code !== 0) {
          reject()
          return
        }
        const dataAry = data.data.list || []
        dataAry.forEach((d: any) => {
          d.levelNft = d.level
          d.level = 'v3'
        })
        resolve(dataAry)
      })
    })
    .catch(() => [])
  }

  const fetchAsksSort = async (noInfoArts: any, stakeIds: any, stakeIds2: any) => {
    // let ids = ''
    let obj: any = {}
    // noInfoArts.forEach((d, index) => {
    //   obj[d.tokenId] = {...d}
    //   ids = ids + d.tokenId
    //   if (index < noInfoArts.length - 1) {
    //     ids = ids + ','
    //   }
    // })
    let params = {}
    const idsV1 = noInfoArts.v1.join(',')
    const idsV2 = noInfoArts.v2.join(',')
    const idsV3 = noInfoArts.v3.join(',')
    const paramsV1 = {
      ...params,
      ids: idsV1
    }
    const paramsV2 = {
      ...params,
      ids: idsV2
    }
    const paramsV3 = {
      ...params,
      ids: idsV3
    }
    const handleDataArtworks = (arr: any) => {
      const artworks = arr.map((d: any) => {
        return {
          ...d,
          level: d.level,
          levelNft: d.levelNft,
          tokenId: d.id,
          ...obj[+d.id],
          staking: stakeIds.includes(d.id) ? true : false,
          staking2: stakeIds2.includes(d.id) ? true : false,
          bakeAmount: new BigNumber(d.bakeAmount),
          stakingPowerAmount: new BigNumber(d.stakingPowerAmount),
            dishIcon:
              d.items
                .map((s: string | number) => {
                  const valBinary = new BigNumber(s)
                    .div(100000)
                    .integerValue(BigNumber.ROUND_FLOOR)
                    .toString(2)
                  return valBinary.length < 2 ? '0' + valBinary : valBinary
                })
                .join('') + '.svg',
            nftType: 10,
            auctionPrice: ((d.auctionPrice && Number(d.auctionPrice)) && (d.price && Number(d.price) && +d.price === AuctionBake) ? d.auctionPrice : ''),
            maxBidPrice: (d.maxBidPrice && !Number(d.maxBidPrice)) && (d.auctionPrice && Number(d.auctionPrice)) ? d.auctionPrice.toString() : d.maxBidPrice
        }
      })
      return artworks
    }
    let listV1
    let listV2
    let listV3

    if (idsV1) {
      listV1 = await getDataV1(paramsV1)
    } else {
      listV1 = []
    }
    if (idsV2) {
      listV2 = await getDataV2(paramsV2)
    } else {
      listV2 = []
    }
    if (idsV3) {
      listV3 = await getDataV3(paramsV3)
    } else {
      listV3 = []
    }

    const artworksV1 = handleDataArtworks(listV1)
    const artworksV2 = handleDataArtworks(listV2)
    const artworksV3 = handleDataArtworks(listV3)

    setDishes([...artworksV3, ...artworksV2, ...artworksV1])
    // if (level === 'v1') {
    //   getBakeryCombos(chainId as number, params, (err: any, data: any) => {
    //     if (err) return
    //     if (data.code !== 0) return
    //     const dataAry = data.data.list || []
    //     const eggs = dataAry.map((d: any) => {
    //       return {
    //         ...d,
    //         ...obj[+d.id],
    //         dishIcon:
    //           d.items
    //             .map((s: string | number) => {
    //               const valBinary = new BigNumber(s)
    //                 .div(100000)
    //                 .integerValue(BigNumber.ROUND_FLOOR)
    //                 .toString(2)
    //               return valBinary.length < 2 ? '0' + valBinary : valBinary
    //             })
    //             .join('') + '.svg',
    //         nftType: 10,
    //         auctionPrice: ((d.auctionPrice && Number(d.auctionPrice)) && (d.price && Number(d.price) && +d.price === AuctionBake) ? d.auctionPrice : ''),
    //         maxBidPrice: (d.maxBidPrice && !Number(d.maxBidPrice)) && (d.auctionPrice && Number(d.auctionPrice)) ? d.auctionPrice.toString() : d.maxBidPrice
    //       }
    //     })
    //     setDishes(eggs)
    //   })
    // } else {
    //   getBakeryCombosV2(chainId as number, params, (err: any, data: any) => {
    //     if (err) return
    //     if (data.code !== 0) return
    //     const dataAry = data.data.list || []
    //     const eggs = dataAry.map((d: any) => {
    //       return {
    //         ...d,
    //         ...obj[+d.id],
    //         dishIcon:
    //           d.items
    //             .map((s: string | number) => {
    //               const valBinary = new BigNumber(s)
    //                 .div(100000)
    //                 .integerValue(BigNumber.ROUND_FLOOR)
    //                 .toString(2)
    //               return valBinary.length < 2 ? '0' + valBinary : valBinary
    //             })
    //             .join('') + '.svg',
    //         nftType: 10,
    //         auctionPrice: ((d.auctionPrice && Number(d.auctionPrice)) && (d.price && Number(d.price) && +d.price === AuctionBake) ? d.auctionPrice : ''),
    //         maxBidPrice: (d.maxBidPrice && !Number(d.maxBidPrice)) && (d.auctionPrice && Number(d.auctionPrice)) ? d.auctionPrice.toString() : d.maxBidPrice
    //       }
    //     })
    //     setDishes(eggs)
    //   })
    // }
  }

  useEffect(() => {
    if (account) {
      fetchAllDishes()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account])

  useInterval(fetchAllDishes, account ? 10000 : null)

  const allowanceSellAll = useAllowanceAll(
    {
      type: MARKETTYPEV3.DISHV3,
      marketFlag: 'market'
    }
  )

  // toggle wallet when disconnected
  const toggleWalletModal = useWalletModalToggle()
  return (
    <>
      <BodyHead>
        <BodyTitle fontSize={32} fontWeight={700}>
          My Combos
        </BodyTitle>
        <Text fontSize={14} fontWeight={500}>
          Wish you best of luck in making Combos{' '}
          <span role="img" aria-label="smile">
            😋
          </span>
        </Text>
      </BodyHead>
      {!!account ? (
        <>
          <ExchangeBakeVersion />
          <StakeRow type={gameType}></StakeRow>
          <MyDishesList dishes={dishes} currentBlock={currentBlock} allowanceSellAll={allowanceSellAll} type={gameType}></MyDishesList>
        </>
      ) : (
        <ButtonLightOverride onClick={toggleWalletModal}>Connect Wallet</ButtonLightOverride>
      )}
    </>
  )
}
